import _property from 'lodash/property'

const id = _property('id')
const enhancedReview = _property('enhancedReview')
const person = _property('person')
const roles = _property('roles')
const specialties = _property('specialties')
const userType = _property('userType')

export default {
  id,
  enhancedReview,
  person,
  roles,
  specialties,
  userType
}
